import {
  LOCKED_LABEL,
  LockedGate,
  type LockedGateProps,
  LockedMark,
  lockedOption,
} from '@/shared/modules/permissions/locked-item';

export const LOCKED_CATEGORY_REASON = "You don't have access to this category.";
export const LOCKED_CATEGORY_LABEL = LOCKED_LABEL;
export const OPEN_CATEGORY_REQUIRED_REASON =
  'Choose at least one category you have access to. A contact outside your categories is hidden from you.';
export const NO_OPEN_CATEGORY_REASON =
  'You need access to at least one category to add a contact. Ask an admin to grant your role a category.';

export const LockedCategoryMark = () => <LockedMark />;

export const lockedCategoryOption = lockedOption;

export const LockedCategoryGate = (props: Omit<LockedGateProps, 'reason'>) => (
  <LockedGate reason={LOCKED_CATEGORY_REASON} {...props} />
);
